import React, { useEffect } from 'react';
import styled from 'styled-components';
import Loading from '../components/Loading';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import { useState } from 'react';
import { API_HOST, EXAMS_UI_HOST } from '../consts';
import Axios from 'axios';


const ExternalApplicationMiddlewarePage = ({ className, location }) => {
  const { applicationName, path, forceLogout } = queryString.parse(location.search);
  const [ middlewareToken, setMiddlewareToken ] = useState(null)

  useEffect(() => {
    const h = async () => {
      const response = await Axios.post(`${API_HOST}/external-auth/bridge_token`)

      setMiddlewareToken(response.data.token)
    }

    h()
  }, [])

  const goToExams = async () => {
    if (forceLogout === 'true') {
      localStorage.removeItem('token')
    }

    window.location.replace(`${EXAMS_UI_HOST}/educat-bridge/${middlewareToken}?next=${path}`)
  }

  useEffect(() => {
    if (middlewareToken && applicationName) {
      switch (applicationName) {
        case 'exams':
          return goToExams()
      }
    }
  }, [middlewareToken, applicationName])

  return (
      <div className={className}>
        <Loading />
      </div>
  );
};

export default styled(withRouter(ExternalApplicationMiddlewarePage))`
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  flex-direction: column;
  p {
    margin-top: 0.5rem;
    font-weight: bold;
  }
`;
